import React, { useContext } from 'react'
import { useQuery } from 'react-query'
import { DashboardContext } from '../Context/DashboardContext'
import AuthAxios from '../utils/AuthAxios'





const getbannedUser = async () => {
    const response = await AuthAxios.get(`/user/banned`);
    const data = response.data.data;
    return data;
  };
  
  export const useGetBannedUser = () => {
    const { setallbannedUsers } = useContext(DashboardContext);
    return useQuery("fetch banned user ", () => getbannedUser(), {
      refetchOnWindowFocus: false,

      onSuccess: (data) => {
        // console.log(data, "banned data")
        setallbannedUsers(data);
      },
    });
  };
  
